import React from 'react';

import type { IResourceDatabaseRecord, IResourceItemType } from '@/api/types';
import type { IResourceViewProps } from '@/api/types';

import { getResourceItemType } from '@/helpers';

import { SimpleResourcePreviewBody } from './SimpleResourcePreviewBody';
import { DatabaseResourcePreviewBody } from './DatabaseResourcePreviewBody';

interface IPreviewBodyProps {
  resource: IResourceItemType | IResourceDatabaseRecord;
  fields?: IResourceViewProps[];
}

const PreviewBody = ({ resource }: IPreviewBodyProps): React.ReactElement => {
  switch (getResourceItemType(resource)) {
    case 'document':
    case 'link':
    case 'announcement':
      return <SimpleResourcePreviewBody resource={resource as IResourceItemType} />;
    case 'database':
      return <DatabaseResourcePreviewBody resource={resource as IResourceDatabaseRecord} />;
    default:
      return <></>;
  }
};

export { PreviewBody };
